module.exports = __webpack_public_path__ + "img/game-logo.235f1791.png";